requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('search-form')) {
      class SearchForm extends HTMLElement {
        constructor() {
          super();

          this.input = this.querySelector('input[type="search"]');
          this.resetButton = this.querySelector('button[type="reset"]');

          this.onResetBound = this.onFormReset.bind(this);
          this.onInputBound = (event) => {
            clearTimeout(this.inputTimer);
            // Invalidate reads immediately, before the debounce can fire.
            this.onInputChange?.(event);
            this.inputTimer = setTimeout(() => {
              if (this.isConnected) this.onChange(event);
            }, 300);
          };
        }

        connectedCallback() {
          if (!this.input || this.searchFormConnected) return;
          this.searchFormConnected = true;
          this.input.form.addEventListener('reset', this.onResetBound);
          this.input.addEventListener('input', this.onInputBound);
        }

        disconnectedCallback() {
          clearTimeout(this.inputTimer);
          this.input?.form?.removeEventListener('reset', this.onResetBound);
          this.input?.removeEventListener('input', this.onInputBound);
          this.searchFormConnected = false;
        }

        toggleResetButton() {
          if (!this.resetButton) return;
          const resetIsHidden = this.resetButton.classList.contains('hidden');
          if (this.input.value.length > 0 && resetIsHidden) {
            this.resetButton.classList.remove('hidden')
          } else if (this.input.value.length === 0 && !resetIsHidden) {
            this.resetButton.classList.add('hidden')
          }
        }

        onChange() {
          this.toggleResetButton();
        }

        shouldResetForm() {
          return !document.querySelector('[aria-selected="true"] a')
        }

        onFormReset(event) {
          event.preventDefault();
          clearTimeout(this.inputTimer);
          if (this.shouldResetForm()) {
            this.input.value = '';
            this.input.focus();
            this.toggleResetButton();
          }
        }
      }

      customElements.define('search-form', SearchForm);

      window.SearchForm = SearchForm;
      scriptController.scripts.push('search-form.js');
    }
  });
});